module.exports = "/_next/static/images/989573ac7003ed2b1843c4751b61b11c-value_proposal_lg.png.webp";